export default "__VITE_ASSET__BOxAxxhy__";